import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  setPhoneNumberPrimary,
  setPhoneNumberPrimaryType,
  setPhoneNumberSecondaryType,
  setPhoneNumberSecondary,
} from '../user-profile/profileReducer';
import {
  PhoneEditContainer,
  PhoneRowContainer,
  PhoneSelect,
  PhoneSelectorContainer,
  PrimaryPhoneLabel,
  PrimaryPhoneNumberInput,
  PrimaryPhoneRequiredField,
  SecondaryPhoneNumberInput,
  SecondaryPhoneNumberLabel,
  SecondaryPhoneSelect,
} from './styles';
import { formatPhoneNumber } from '../../../utils/validators/generalValidators';
import TooltipInfo from '../../common/tooltip';
import { getText } from '../../../utils/i18n';

const EditingPhones = (props) => {
  const {
    ariaLabel,
    dispatch,
    standardPhoneLength,
    phoneNumberPrimary,
    phoneNumberSecondary,
    phoneNumberPrimaryType,
    phoneNumberSecondaryType,
    i18n,
  } = props;
  const handlePrimaryPhoneChange = (phone) => {
    dispatch(setPhoneNumberPrimaryType(phone));
  };
  const handleSecondaryPhoneChange = (phone) => {
    dispatch(setPhoneNumberSecondaryType(phone));
  };
  const phoneTypeSelector = [
    { value: 'Mobile', label: 'Mobile' },
    { value: 'Home', label: 'Home' },
    { value: 'Business', label: 'Business' },
    { value: 'Other', label: 'Other' },
  ];
  return (
    <>
      <PhoneEditContainer isDashboard={true}>
        <PhoneRowContainer isDashboard={true}>
          <PrimaryPhoneLabel>
            Primary phone <TooltipInfo title={getText(i18n, 'profile.primaryPhoneTooltip')} />
          </PrimaryPhoneLabel>
          <PrimaryPhoneRequiredField>*</PrimaryPhoneRequiredField>
          <PrimaryPhoneNumberInput isDashboard={true}>
            <input
              aria-label={ariaLabel}
              value={phoneNumberPrimary}
              onChange={(e) => {
                dispatch(setPhoneNumberPrimary(formatPhoneNumber(e.target.value)));
              }}
              maxLength={standardPhoneLength ? 14 : 20}
            />
          </PrimaryPhoneNumberInput>
          <PhoneSelectorContainer>
            <PhoneSelect
              id="phoneTypeSelector"
              isDashboard={true}
              options={phoneTypeSelector}
              value={phoneNumberPrimaryType}
              onChange={handlePrimaryPhoneChange}
            />
          </PhoneSelectorContainer>
        </PhoneRowContainer>
        <PhoneRowContainer isDashboard={true}>
          <SecondaryPhoneNumberLabel>
            Secondary phone <span style={{ color: '#657580' }}>(Optional)</span>
            <TooltipInfo title={getText(i18n, 'profile.secondaryPhoneTooltip')} />
          </SecondaryPhoneNumberLabel>
          <SecondaryPhoneNumberInput isDashboard={true}>
            <input
              value={phoneNumberSecondary}
              onChange={(e) => {
                dispatch(setPhoneNumberSecondary(formatPhoneNumber(e.target.value)));
              }}
            />
          </SecondaryPhoneNumberInput>
          <PhoneSelectorContainer>
            <SecondaryPhoneSelect
              isDashboard={true}
              options={phoneTypeSelector}
              value={phoneNumberSecondaryType}
              onChange={handleSecondaryPhoneChange}
            />
            <PrimaryPhoneRequiredField> </PrimaryPhoneRequiredField>
          </PhoneSelectorContainer>
        </PhoneRowContainer>
      </PhoneEditContainer>
    </>
  );
};

EditingPhones.propTypes = {
  ariaLabel: PropTypes.string,
  cancelPhone: PropTypes.func,
  customerSubscriptionsFull: PropTypes.any,
  customer: PropTypes.object,
  customerId: PropTypes.string,
  dispatch: PropTypes.func,
  isDashboard: PropTypes.bool,
  notificationPhone: PropTypes.string,
  phoneNumberPrimary: PropTypes.string,
  phoneNumberPrimaryRetrieved: PropTypes.string,
  phoneNumberSecondary: PropTypes.string,
  phoneNumberSecondaryId: PropTypes.string,
  primaryPhoneName: PropTypes.string,
  primaryPhoneNameType: PropTypes.string,
  secondaryPhoneName: PropTypes.string,
  secondaryPhoneNameType: PropTypes.string,
  standardPhoneLength: PropTypes.bool,
  i18n: PropTypes.object,
};
const mapStateToProps = (state) => ({
  phoneErrors: state.profileSlice.phoneErrors,
  standardPhoneLength: state.configurationSlice.features.features.standardPhoneLength,
  editingPhone: state.profileSlice.editingPhone,
  customerId: state.loginSlice.user.preferred_username,
  systemId: state.customerSlice.customer.systemId,
  customer: state.customerSlice.customer,
  customerSubscriptionsFull: state.notificationSlice.customerSubscriptionsFull,
  notificationPhone: state.notificationSlice.notificationPhone,
  phoneNumberPrimary: state.profileSlice.phoneNumberPrimary,
  phoneNumberPrimaryType: state.profileSlice?.phoneNumberPrimaryType,
  phoneNumberSecondaryType: state.profileSlice?.phoneNumberSecondaryType,
  phoneNumberSecondary: state.profileSlice.phoneNumberSecondary,

  i18n: state.i18nSlice.i18n,
});
EditingPhones.defaultProps = {
  state: {},
};

export default connect(mapStateToProps)(EditingPhones);
